export const RISK_STYLE = {
  KRITIS: "bg-red-700 text-white", TINGGI: "bg-red-100 text-red-800 border border-red-300",
  SEDANG: "bg-amber-100 text-amber-900 border border-amber-300", RENDAH: "bg-slate-100 text-slate-700 border border-slate-200",
};
export const STATUS_LABEL = { BARU: "Baru", DITINJAU: "Ditinjau", DITANGANI: "Ditangani" };

export const wib = (iso) => (iso ? `${new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "medium", timeStyle: "short" })} WIB` : "-");

export const RiskBadge = ({ risk }) => <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${RISK_STYLE[risk]}`} data-testid="risk-badge">{risk}</span>;

export const StatusBadge = ({ status }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${status === "DITANGANI" ? "bg-emerald-100 text-emerald-800" : "bg-sky-100 text-sky-800"}`} data-testid="status-badge">{STATUS_LABEL[status]}</span>
);
